import { cn } from '../../lib/utils'
import React from 'react'

function InputError(props: {
    children: React.ReactNode,
    className?: string,
}) {
    return (
        <span 
            role='alert'
            className={cn("text-sm text-destructive", props.className)} 
        >
            {props.children}
        </span>
    )
}

export default InputError